<template>
  <div v-if="new_video || video">
    <Logo
      v-if="$utils.extractUrl(video?.props?.component_props?.url, $route) == 'N/A' && !new_video"
      class="h-24 w-24 absolute ml-5 -mt-28" />
    <video v-else id="video" class="inline-block border rounded-md h-24 max-w-[800px] absolute ml-3 -mt-28" controls>
      <source :src="new_video?.src || $utils.extractUrl(video?.props?.component_props?.url, $route)" type="video/mp4">
    </video>
  </div>
  <div class="flex gap-x-2 mb-10 mt-32 items-center">
    <button class="btn cancel-btn h-10 w-32">
      {{ new_video || video ? $t("Change Video") : $t("Upload Video") }}
    </button>
    <input
      name="file-upload"
      accept="video/*"
      type="file"
      :placeholder="$t('here')"
      class="custom-file-input w-32 h-10 cursor-pointer border"
      @change="(e) => addFiles(e)">

    <span>Or</span>

    <TextInput
      v-model="extern_url"
      :disabled="new_attachments.length"
      :only-alpha-numeric="false"
      :value="extern_url"
      class="w-[270px] max-w-[270px]"
      :is-box-background="true"
      :show-label="false"
      :auto-focus="false"
      input-classes="appearance-none block px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light bg-white focus:border-blue-light sm:text-sm"
      name="name"
      type="text"
      :placeholder="$t('Add Youtube/Vimeo URL')"
      label=""
      @input="extern_url = $event.target.value" />

    <div class="ml-10 flex items-start space-x-3">
      <div class="dark:text-white mt-2">
        {{ $t("Background") }}:
      </div>
      <div class="relative flex flex-col mt-1 items-center justify-center dark:border-dark-divider-border">
        <ColorPickerList v-model:current-item="image_bg_color" />
      </div>
    </div>

    <label v-if="$route.name == 'CompanyProfile' || $route.name == 'ObjectProfile'" class="mt-1.5 ml-4">{{ $t("Show on") }}:</label>
    <SelectInput
      v-if="$route.name == 'CompanyProfile' || $route.name == 'ObjectProfile'"
      v-model="connect_to"
      :disabled="disabled_connect_to_selection"
      name="select_input"
      :allow-null="false"
      :items="connect_to_options"
      :is-box-background="true"
      :value="connect_to"
      label-attr="name"
      value-attr="value"
      :placeholder="$t('Connect to')"
      :label="$t('Connect to')"
      class="w-[200px]"
      input-classes="appearance-none text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm" />
  </div>

  <div class="flex flex-row justify-between w-full gap-2">
    <div class="w-1/2 m-0 cancel-btn" @click="is_loading ? null : $emit('cancel')">
      {{ $t("Cancel") }}
    </div>
    <button
      :class="[!new_video && !bg_color_updated && !extern_url ? 'opacity-50' : '']"
      :disabled="!new_video && !bg_color_updated && !extern_url"
      type="button"
      class="w-1/2 primary-btn"
      @click="updateVideo()">
      {{ is_loading ? $t("Loading...") : video ? $t("Update Video") : $t("Create Video") }}
    </button>
  </div>
</template>

<script>
import SelectInput from "@/components/shared/SelectInput.vue"
import Logo from "@/components/shared/Logo.vue"
import ColorPickerList from "@/components/shared/ColorPickerList.vue"
import TextInput from "@/components/shared/TextInput.vue"

const maxFileAllowedSizeMB = 20
const maxFileAllowedSize = maxFileAllowedSizeMB * 1024 * 1024
export default {
  components: { SelectInput, Logo, ColorPickerList, TextInput },
  props: {
    video: {
      type: Object,
      default: null
    }
  },
  emits: ["setComponentData", "cancel", "submitForm"],
  data() {
    return {
      extern_url: "",
      new_attachments: [],
      new_video: null,
      is_loading: false,
      connect_to: "all_pages",
      connect_to_options: [
        { name: this.$t("All Pages"), value: "all_pages" },
        { name: this.$t("This Page"), value: "this_page" }
      ],
      image_bg_color: "",
      bg_color_updated: false,
      page_identifier: "all",
      disabled_connect_to_selection: false
    }
  },

  watch: {
    connect_to() {
      if (this.connect_to == "this_page") {
        this.page_identifier = `${this.$route.params.object_type}>${this.$route.params.cid}`
      } else {
        this.page_identifier = "all"
      }
      this.setComponentData()
    },
    image_bg_color() {
      this.bg_color_updated = true
      this.setComponentData()
    },
    extern_url() {
      this.setComponentData()
    },
    new_attachments() {
      if (this.new_attachments.length) {
        this.extern_url = null
      }
    }
  },

  created() {
    if (this.video) {
      this.disabled_connect_to_selection = true
      if (typeof this.video.props.component_props.label == "object") {
        this.connect_to = "this_page"
      }
      this.image_bg_color = this.video.props.component_props.backgroundColor
      if (
        this.video.props.component_props?.url &&
        (this.video.props.component_props.url.includes("youtube") ||
          this.video.props.component_props.url.includes("youtu.be") ||
          this.video.props.component_props.url.includes("vimeo"))
      ) {
        this.extern_url = this.video.props.component_props.url
      }
    }
  },

  methods: {
    setComponentData() {
      this.$emit("setComponentData", {
        required_filled: this.new_attachments.length,
        attachments: this.new_attachments,
        backgroundColor: this.image_bg_color,
        url: this.extern_url,
        connectTo: this.connect_to,
        page_identifier: this.page_identifier
      })
    },
    addFiles(event) {
      Array.from(event.target.files).map((file) => {
        if (file.size < maxFileAllowedSize) {
          this.new_attachments = [{ name: file.name, file: file }]
          //this.$utils.replaceOrAddItem(this.new_attachments, { name: file.name, file: file }, "name")
          let video = document.getElementById("video")
          if (!video) {
            video = document.createElement("video")
          }
          video.src = URL.createObjectURL(file)
          this.new_video = video
          this.setComponentData()
        }
      })
    },
    updateVideo() {
      this.$emit("submitForm", {
        id: this.video?.id,
        attachments: this.new_attachments,
        backgroundColor: this.image_bg_color,
        url: this.extern_url,
        component_type: "video",
        connectTo: this.connect_to,
        page_identifier: this.page_identifier
      })
    }
  }
}
</script>

<style scoped>
.rainbow-bg {
  background: conic-gradient(red, yellow, lime, aqua, blue, magenta, red);
}
</style>
